// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"SettingsList_tableContainer__3hITB","cardTitle":"SettingsList_cardTitle__Zz_Xi"};